/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const LightningBoltSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M9.005 2.765C9.13 2.312 9.52 2 9.965 2h6.652c.721 0 1.205.787.916 1.49l-2.429 5.905H17c.811 0 1.284.974.815 1.678l-6.973 10.476c-.582.873-1.876.388-1.813-.681l.348-5.926H7c-.666 0-1.146-.68-.96-1.361L9.006 2.765Z" /></svg>);
const LightningBoltSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={LightningBoltSolidBase} {...rest} ref={ref} />);
export default LightningBoltSolid;